import { LegalContentPage } from "@/components/LegalContentPage";

export default function Seguranca() {
  return (
    <LegalContentPage
      overline="Confiança"
      title="Segurança"
      subtitle="A sua segurança é prioridade para a Miríade Turismo. Veja como cuidamos de você e como você pode se proteger."
      seoTitle="Segurança | Miríade Turismo"
      seoDescription="Saiba como a Miríade Turismo cuida da sua segurança e conheça boas práticas para uma compra de viagem segura."
      intro="Queremos que a sua experiência com a Miríade Turismo seja sempre segura e transparente — do primeiro contato à realização da viagem. Por isso, reforçamos boas práticas e canais oficiais para que você compre com confiança."
      sections={[
        {
          heading: "Compre com tranquilidade",
          paragraphs: ["Adotamos cuidados para que a sua jornada conosco seja segura e confiável. Ainda assim, é importante que você também siga boas práticas ao pesquisar e contratar a sua viagem."],
          list: [
            "Confira sempre se está em um canal oficial da Miríade Turismo.",
            "Desconfie de ofertas com valores muito abaixo do normal ou de cobranças em canais não oficiais.",
            "Em caso de dúvida, confirme as informações diretamente com a nossa equipe.",
          ],
        },
        {
          heading: "Canais oficiais",
          paragraphs: ["O atendimento e a comunicação com a Miríade acontecem pelos nossos canais oficiais, como o WhatsApp e os contatos divulgados neste site. Sempre que tiver qualquer dúvida sobre a autenticidade de uma mensagem ou contato, fale conosco para confirmar."],
        },
        {
          heading: "Atendimento que confirma e orienta",
          paragraphs: ["Nossa equipe está disponível para esclarecer dúvidas, confirmar informações e orientar você em cada etapa. Essa proximidade é parte do nosso compromisso com a sua segurança e a sua tranquilidade."],
        },
        {
          heading: "Proteção dos seus dados",
          paragraphs: ["Tratamos as suas informações com responsabilidade e cuidado. Para saber mais sobre como lidamos com os seus dados, consulte a nossa Política de Privacidade."],
        },
      ]}
      note="Na dúvida, confirme sempre as informações diretamente com a equipe da Miríade Turismo pelos nossos canais oficiais."
      ctaTitle="Quer confirmar alguma informação?"
      ctaText="Fale com a Miríade pelos nossos canais oficiais e tire suas dúvidas com segurança."
    />
  );
}
